import React from 'react';
import styled from 'styled-components';
import cn from 'classnames';
import style from '../style';
import { Core } from 'connex-cds';
import { Detail } from '../ticket-details/logistical-info/material-summary/Detail';
import { useTicketContext } from '../TicketContext';
import GeneralDeliveryInfo from './GeneralDeliveryInfo';
import MaterialInfo from './MaterialInfo';
import QRCode from './QRCode';
import { useCompanySetup } from '../MasterDataProvider';
import { useGetCocSetup } from '../wizard/steps/dot-workflow/DotWorkflow';
import { buildTemplateContext } from './buildTemplateContext';

const { Tabs } = Core;

const Styled = styled.div`
  ${style}

  .ant-tabs-content {
    font-size: 1.3em !important;
  }

  .material-summary,
  .general-delivery-info,
  .material-info {
    font-size: 1.3em !important;
  }

  [data-testid='material-summary-text'],
  [data-testid='general-delivery-info-text'],
  [data-testid='material-info-text'] {
    font-size: 1.3em !important;
  }
`;
const DeliveryInformation = () => {
  const { ticket } = useTicketContext();
  const companySetup = useCompanySetup();
  const cocSetup = useGetCocSetup();

  const cocData = React.useMemo(() => {
    if (!cocSetup?.isLoading) {
      return cocSetup?.data?.testsResult?.consumptions || [];
    }

    return [];
  }, [cocSetup?.isLoading, cocSetup?.data]);

  const templateContext = React.useMemo(() => buildTemplateContext({ ticket, cocData }), [ticket, cocData]);

  const tabConfig = React.useMemo(() => {
    const config = {
      tabs: [
        {
          stringId: 'materialSummary',
          testId: 'materialSummaryLabel',
          component: <Detail data={templateContext} />,
        },
      ],
      translate: [{ getPath: 'stringId', setPath: 'name' }],
    };

    if (ticket?.customData?.ticketType !== 'PMP') {
      config.tabs.push(
        {
          stringId: 'generalDelivery',
          testId: 'generalDeliveryLabel',
          component: <GeneralDeliveryInfo data={templateContext}></GeneralDeliveryInfo>,
        },
        {
          stringId: 'materialInfo',
          testId: 'materialInfoLabel',
          component: <MaterialInfo data={templateContext}></MaterialInfo>,
        }
      );
    }

    if (companySetup?.data?.isQrCodeEnabled && ticket?.customData?.ticketType !== 'PMP') {
      config.tabs.push({
        stringId: 'qrCode',
        testId: 'qrCodeLabel',
        component: <QRCode />,
      });
    }
    return config;
  }, [companySetup, ticket, templateContext]);

  return (
    <Styled className={cn('test-form')}>
      <div>
        <Tabs config={tabConfig} />
      </div>
    </Styled>
  );
};

export default DeliveryInformation;
